export default "__VITE_ASSET__BdqaPPZ8__"